import { render, staticRenderFns } from "./add_kuaishou.vue?vue&type=template&id=33a3b9b8&scoped=true&"
import script from "./add_kuaishou.vue?vue&type=script&lang=js&"
export * from "./add_kuaishou.vue?vue&type=script&lang=js&"
import style0 from "./add_kuaishou.vue?vue&type=style&index=0&id=33a3b9b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a3b9b8",
  null
  
)

export default component.exports